import { atom } from 'recoil';

export const teacherScreenViewState = atom({
  key: 'teacherScreenViewState',
  default: 'call',
});

export const selectedParticipantIdState = atom({
  key: 'selectedParticipantIdState',
  default: null,
});
